import {
  CLEAR_CARD_MOVEMENTS,
  CLEAR_CARD_MOVEMENTS_OPTIONS,
  LOAD_CARD_MOVEMENTS,
  SAVE_CARD_MOVEMENTS_OPTIONS
} from '../actions/cardMovementsActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  },
  items: [],
  count: 0
};

const cardMovementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CARD_MOVEMENTS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count
      };
    }
    case SAVE_CARD_MOVEMENTS_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_CARD_MOVEMENTS_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case CLEAR_CARD_MOVEMENTS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default cardMovementsReducer;
